import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './glide-dialog.component.html'
})
export class GlideDialogComponent {

  constructor(public dialogRef: MatDialogRef<GlideDialogComponent>) {
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }

  title: string;
  message: string;
  buttonLabel: string = 'OK'; // default value

}
